module.exports = "<script src=\"dist/app.js\"></script>"